module.exports = __webpack_public_path__ + "static/media/chef.51a2d392.png";